// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VehicleDetailsContainer_wrapper__tl6ht"};